import React from 'react';
import Loader from 'react-loader-spinner'

const CustomLoader = (props) => {
    return (
        <>
        <tr>
            <td colSpan={60} style={{textAlign: 'center', padding: '32px 0'}}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <Loader
                        type={props.type}
                        color={props.color}
                        height={props.width}
                        width={props.height}
                    />
                    <span style={{
                        fontSize: '12px',
                        color: '#94A3B8',
                        fontWeight: '500'
                    }}>Loading data...</span>
                </div>
            </td>
        </tr>
        </>
    );
}

export default CustomLoader;

CustomLoader.defaultProps = {
    customstyles: {"marginTop":'1.5em',"marginBottom":'1.5em' },
    width: 40,
    height: 40,
    color:"#10B981",
    type: "Oval",
}
